import defaultAnalyticsConfig from "../../../src/common/analytics/defaultAnalyticsConfig";

let erTag = defaultAnalyticsConfig.erTag;
if (process.env.ENV === "production") {
  erTag = "f96799994ccd4c30b5a815b593afbb06";
}

export default class analyticsConfig extends defaultAnalyticsConfig {
  static erTag = erTag;
  static erUserReferenceType = "subscriptionReference";

  static cmp = {
    hasPreferenceView: true,
    key: "11ef8ac9-6270-4d5e-8b99-8d6a5bd60059",

    features: {
      ER: true,
      socialSharing: false,
    },
    ER: {
      vendorId: "c:twipe-CkitNzXD",
      purposeId: [
        "cookies",
        "measure_content_performance",
        "market_research",
        "improve_products",
      ],
    },
  };
}



// WEBPACK FOOTER //
// ./clients/mhu-ds/js/analyticsConfig.js